export { default as default } from './modules/ReactTimeAgo'



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-time-ago/index.js
// module id = 817
// module chunks = 0